import { useEffect, useMemo, useState } from "react"

export const useFetch = (fn, initialState, params) => {
    const [data, setData] = useState(initialState)
    const [loading, setLoading] = useState(initialState)
    useEffect(() => {
        (async () => {
            setLoading(true)
            try {
                const response = await fn(params)
                setData(response)
            } catch (error) {
                console.log(error)
            }
            setTimeout(()=> setLoading(false), 500)
        })()
    }, [params])

    return [ data, setData, loading ]
}